// extracted by mini-css-extract-plugin
export default {"button":"ReportCard_button__dMySP","link":"ReportCard_link__06UC7"};